import { useRouter } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

const STORAGE_PREFIX = "route_persistence";

function getStorageKey(company: string, section: string) {
  return `${STORAGE_PREFIX}_${company}_${section}`;
}

export function useRoutePersistence(tenantSlug: string, section: string) {
  const router = useRouter();
  const basePathRef = useRef<string | null>(null);

  useEffect(() => {
    if (basePathRef.current === null) {
      basePathRef.current = router.state.location.pathname;
    }

    const unsubscribe = router.subscribe("onResolved", (event) => {
      const pathname = event.toLocation.pathname;

      if (basePathRef.current && !pathname.startsWith(basePathRef.current)) {
        return;
      }

      const key = getStorageKey(tenantSlug, section);
      sessionStorage.setItem(key, pathname);
    });

    return unsubscribe;
  }, [router, tenantSlug, section]);

  return null;
}

export function getPersistedRoute(
  company: string,
  section: string,
): string | null {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(getStorageKey(company, section));
}
